import confetti from "canvas-confetti";
import GBtn from "./GBtn";

type Props = Omit<React.ComponentProps<typeof GBtn>, "handleClick">;

export default function GBtnConfetti(props: Props) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();

    confetti({
      spread: 70,
      ticks: 100,
      gravity: 0.7,
      startVelocity: 30,
      particleCount: 90,
      scalar: 1.2,
      origin: {
        x: e.clientX / window.innerWidth,
        y: e.clientY / window.innerHeight,
      },
    });
  };

  return <GBtn handleClick={handleClick} {...props}></GBtn>;
}

// We need to add the below in framer

/*
addPropertyControls(Button, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    fontColor: {
        title: "Font Color",
        type: ControlType.Color,
        defaultValue: "#fff",
    },
    background: {
        title: "Background",
        type: ControlType.Color,
        defaultValue: "#854DFF",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 16,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
    radius: {
        title: "Radius",
        type: ControlType.Number,
        defaultValue: 8,
    },
    url: {
        title: "URL",
        type: ControlType.Link,
        defaultValue: "Home",
    },
    ripple: {
        title: "Ripple",
        type: ControlType.Boolean,
        description: "Adds a ripple effect on click if true",
        defaultValue: true,
    },
})
*/
